import { render, staticRenderFns } from "./log_list.vue?vue&type=template&id=bbbf7f22&scoped=true"
import script from "./log_list.vue?vue&type=script&lang=js"
export * from "./log_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf7f22",
  null
  
)

export default component.exports